import React from "react";
import { FaMailBulk } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Chitra (CanCanaryCan)</h3>
        <p className="text-lg font-normal text-gray-400">Streamer</p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email:{" "}
          <span className="text-lightText">heyitsblackcanary@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex gap-4">
          <a
            href="mailto:heyitsblackcanary@gmail.com"
            className="bannerIcon"
            aria-label="Send email to Chitra"
          >
            <FaMailBulk />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
